import { render, staticRenderFns } from "./SlickCarouselSsr.vue?vue&type=template&id=6c0f6861&lang=pug"
import script from "./SlickCarouselSsr.vue?vue&type=script&lang=js"
export * from "./SlickCarouselSsr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports